import axios from "axios";
import apiUrls from "../apiUrls";

let fetchUserPromise = null; // To handle simultaneous calls
let userWasFetched = false;

const state = {
  isGuest : window.isGuest == undefined ? true : window.isGuest,
  user : window.user || null,
  newProducts : window.user ? window.user.new_products : [],
  usedProducts : window.user ? window.user.used_products : []
}

const getters = {
  isGuest: (state) => state.isGuest && (window.isGuest === true || window.isGuest === undefined),
  getUser: (state) => state.user,
  getNewProducts: (state) => state.newProducts,
  getUsedProducts: (state) => state.usedProducts,
  getNewProductBySku: (state) => (sku) => state.newProducts.find(p => p.product_sku == sku) || null,
  getUsedProductById: (state) => (id) => state.usedProducts.find(p => p.product_id == id) || null,
  getEmail: (state) => state.user ? state.user.username : null
};

const mutations = {

  SET_IS_GUEST(state, isGuest) {
    state.isGuest = isGuest
  },

  SET_USER(state, user) {
    state.isGuest = user == null;
    state.user = user;

    //arrays should stay reactive:
    // Clear the arrays
    state.newProducts.splice(0, state.newProducts.length);
    state.usedProducts.splice(0, state.usedProducts.length);

    // Add new items to newProducts
    if (user.new_products) {
      user.new_products.forEach(product => {
        state.newProducts.push(product);
      });
    }

    // Add new items to usedProducts
    if (user.used_products) {
      user.used_products.forEach(product => {
        state.usedProducts.push(product);
      });
    }
    //
    // state.newProducts = user.new_products || [];
    // state.usedProducts = user.used_products || [];
  },

  SET_NEW_PRODUCT(state, product) {
    const index = state.newProducts.findIndex(p => p.product_sku == product.product_sku)
    if (index >= 0){
      state.newProducts.splice(index, 1, product)
    } else {
      state.newProducts.push(product)
    }
  },

  DELETE_NEW_PRODUCT(state, sku) {
    const index = state.newProducts.findIndex(p => p.product_sku == sku)
    if (index >= 0){
      state.newProducts.splice(index, 1)
    }
  },

  SET_USED_PRODUCT(state, product) {
    const index = state.usedProducts.findIndex(p => p.product_id == product.product_id)
    if (index >= 0){
      state.usedProducts.splice(index, 1, product)
    } else {
      state.usedProducts.push(product)
    }
  },

  DELETE_USED_PRODUCT(state, id) {
    const index = state.usedProducts.findIndex(p => p.product_id == id)
    if (index >= 0){
      state.usedProducts.splice(index, 1)
    }
  },
};

const actions = {

  async fetchUser({ state, commit }, d) {

    try {
      // Simulate an API call to fetch user data
      const userResponse = await axios.get(apiUrls.self)
      commit('SET_USER', userResponse.data.user);
      return userResponse.data.user;
    } catch (error) {

    }
  },

  getUserOnce({ state, dispatch, commit }, d) {
    if (state.isGuest && window.isGuest) {
      return null;
    }

    if (state.user) {
      return state.user;  // User is already in the store, return it
    }

    if (window.user){
      let user = window.user
      commit('SET_USER', user)
      return user
    }

    if (userWasFetched){
      return null
    }

    userWasFetched = true

    if (!fetchUserPromise) {
      fetchUserPromise = dispatch('fetchUser').finally(() => {
        fetchUserPromise = null;  // Reset the promise after fetching
      });
    }

    // Wait for the user to be fetched and then return it
    return fetchUserPromise;
  },

  async removeProduct( { commit}, { isNew, id }) {
      if (isNew){
        commit('DELETE_NEW_PRODUCT', id)
      } else {
        commit('DELETE_USED_PRODUCT', id)
      }
  },

  async setProduct( { commit}, { isNew, product } ) {
      if (isNew){
        commit('SET_NEW_PRODUCT', product)
      } else {
        commit('SET_USED_PRODUCT', product)
      }
  },
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
};



// WEBPACK FOOTER //
// ./resources/js/store/modules/user.js